
export const BuyerAuthMutation = new TypedDocumentString(`
    mutation BuyerAuthMutation($input: InputBuyerAuth!) {
  buyerAuth(input: $input) {
    responseInfo {
      ...ResponseInfo
      __typename
    }
    me {
      ...AuthMe
      __typename
    }
    codeRefNumber {
      ...AuthCodeRef
      __typename
    }
    authChanged
    emailStatus
    urlCodeValid
    emailInvalid
    urlCodeValidCb
    __typename
  }
}
    fragment ResponseInfo on ResponseInfo {
  success
  message
  status
  error
  __typename
}
fragment BuyerAddressDefault on BuyerAddressDefault {
  iso2
  city
  countryName {
    value
    __typename
  }
  __typename
}
fragment UserDoc on UserDoc {
  email
  buyerCartSize
  name
  lastname
  publicName
  isPublic
  roles
  gender
  birthdate
  buyerNotifications
  address {
    ...BuyerAddressDefault
    __typename
  }
  __typename
}
fragment AuthMe on Me {
  _id
  isAuth
  type
  lang
  user {
    _id
    isMe
    isEmailVerified
    _b2b {
      sellerId
      hasPricing
      __typename
    }
    doc {
      ...UserDoc
      __typename
    }
    __typename
  }
  __typename
}
fragment AuthCodeRef on AuthCodeRef {
  _id
  codeRefNumber
  __typename
}`, {"hash":"5bfa1b4524ff2bf0274d79184587071793248aa42ebefd208deb04b6b0be91a1"});